/**
 * API base URL for the React app (axios).
 * Set REACT_APP_API_URL at build time for each environment, e.g.:
 *   local:  http://localhost:5001/api/v1/
 *   prod:   https://app.finlotax.com/api/v1/
 * Backend auth is the same in every environment once deployed.
 *
 * On localhost dev, remote prod URLs in .env are ignored unless
 * REACT_APP_ALLOW_REMOTE_API_ON_LOCALHOST=true.
 */
const LOCAL_API = "http://localhost:5001/api/v1/";
const PROD_API = "https://app.finlotax.com/api/v1/";

function trimEnvUrl(value) {
  if (value == null || String(value).trim() === "") return "";
  return String(value).trim().replace(/\s+/g, "");
}

function isLocalHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "::1";
}

function isRemoteFinlotaxApi(url) {
  return /app\.finlotax\.com|staging\.finlotax\.com/i.test(url || "");
}

function ensureTrailingSlash(url) {
  return url.endsWith("/") ? url : `${url}/`;
}

function resolveApiUrl() {
  const fromEnv = trimEnvUrl(process.env.REACT_APP_API_URL);
  const onLocal = isLocalHost();
  const allowRemoteOnLocal =
    String(process.env.REACT_APP_ALLOW_REMOTE_API_ON_LOCALHOST || "")
      .toLowerCase() === "true";

  if (onLocal && !allowRemoteOnLocal) {
    if (!fromEnv || isRemoteFinlotaxApi(fromEnv)) {
      if (fromEnv && isRemoteFinlotaxApi(fromEnv)) {
        console.warn(
          "[FinloTax] localhost UI → local API (5001). Remote URL ignored:",
          fromEnv
        );
      }
      return LOCAL_API;
    }
    return ensureTrailingSlash(fromEnv);
  }

  if (fromEnv) return ensureTrailingSlash(fromEnv);
  return onLocal ? LOCAL_API : PROD_API;
}

export const API_URL = resolveApiUrl();

export const adminEmail = "admin@finlotax.com";
